import React, { FunctionComponent, Fragment, useEffect, useContext } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { injectIntl } from 'react-intl'
import { AppContext } from 'src/AppContext'
import { asyncComponent } from 'src/lib/async-component'
import { setDigitalData, googleTagManagerEvent } from 'src/lib/digital-data'
import { trackAmplitude } from 'src/lib/analytics'
import { Header } from 'src/components/calendar/Header'
import { Event } from 'src/components/calendar/event'
import { NotFound } from 'src/routes/NotFound'

const style = require('./Calendar.css')
const eventSetQuery = require('./event-set.gql')

import { useQuery } from '@apollo/react-hooks'

const Navbar = asyncComponent(() => (
  import(/* webpackChunkName: "components-navbar", webpackPreload: true */ 'src/components/Navbar/Navbar')
), 'Navbar')

const Footer = asyncComponent(() => (
  import(/* webpackChunkName: "components-footer", webpackPrefetch: true */ 'src/components/Footer/Footer')
), 'Footer')

const Search = asyncComponent(() => (
  import(/* webpackChunkName: "components-search" */ 'src/components/search/index')
), 'Search')


const CalendarComponent: FunctionComponent<RouteComponentProps> = ({ match, history }) => {
  useEffect(() => window.scrollTo(0, 0), [])

  const [searchShown, setSearchShown] = React.useState(false)
  const toggleSearch = () => setSearchShown(!searchShown)

  const { viewer, viewerFetched } = useContext(AppContext)

  const { slug } = match.params

  setDigitalData({
    channel: 'event-display-page',
    type: 'Event Display Page',
    country: SSR_DATA.countryCode,
  })

  if (viewerFetched) {
    const { searchParams }: URL = new URL(window.location.href)
    trackAmplitude('EDP: View', { ref: searchParams.get('ref') }, viewer)
    googleTagManagerEvent({ event: 'virtualPageView' })
  }

  const { data, loading, error } = useQuery(
    eventSetQuery,
    { variables: { id: slug } },
  )

  if (error) return <NotFound />
  if (!data) return null;

  if (searchShown) {
    return (
      <Search
        closeSearch={toggleSearch}
        lat={SSR_DATA.lat}
        lon={SSR_DATA.lon}
        locationQuery={SSR_DATA.cityName}
        viewer={viewer}
        page="edp"
        sectionId={"search_bar"}
        history={history}
      />
    )
  }

  const eventData = data && data.eventSet

  return (
    <div className={style.container}>
      <Navbar transparent shadow className={style.navbar} toggleSearch={toggleSearch} showSearchBar />
      <Fragment>
        <Header eventData={eventData} loading={loading} isEventSet />
        <Event slug={slug} eventData={eventData} loading={loading} isEventSet />
      </Fragment>
      <Footer />
    </div>
  )
}

export const Calendar = injectIntl(CalendarComponent)
